import React, { useEffect, useState } from 'react';
import { Formik, Field, Form, ErrorMessage} from 'formik';
import * as Yup from 'yup';
import Navbar from './Navbar';
import { Auth } from '@aws-amplify/auth';
import { useNavigate } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.css';
import { Line } from 'react-chartjs-2';
import 'chart.js/auto';

const GetStats = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [stats, setStats] = useState([]);
    const [transformedData, setTransformedData] = useState([]);
    const [dates, setDates] = useState([]);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [link, setLink] = useState('');
    const[linkText, setLinkText] = useState('');
    const [idToken, setIdToken] = useState('');
    const [chartData, setChartData] = useState({});
  
    const navigate = useNavigate();
  
    useEffect(() => {
        checkLogin();
    }, []);

    async function checkLogin() {
        try {
            const user = await Auth.currentAuthenticatedUser();
            setIdToken(user.signInUserSession.idToken.jwtToken);
            setIsLoggedIn(true);
            
         } catch {
            setIsLoggedIn(false);
            navigate('/login');
        }
    }
  
    useEffect(() => {
        
        if (isLoggedIn){
            console.log('Logged in');
            setLink('/logout');
            setLinkText('Logout');  
            setIsLoading(true);  
            getStats();
        }else{
            console.log('Not logged in');
            setLink('/login');
            setLinkText('Login');   

        }
    }, [isLoggedIn]);

    const handleSubmit = async (values) => {
    };

    const getStats = async () => {
        const apiUrl = 'https://1qk0vhgbua.execute-api.ap-southeast-1.amazonaws.com/prod/getstats';
        const data = {
            "mode":"get"
        };

        const dimensionNamesMapping = {
            staff_group1_count: "Staff Grp 1",
            staff_group2_count: "Staff Grp 2",
            staff_group3_count: "Staff Grp 3",
            staff_group4_count: "Staff Grp 4",
            staff_group5_count: "Staff Grp 5",
            airport_staff_count: "Airport Staff",
            crsp_staff_count: "CRSP"
        };

        const formatDate = (dateString) => {
            const options = { day: 'numeric', month: 'short', year: '2-digit' };
            return new Date(dateString).toLocaleDateString('en-GB', options);
        };

        await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': '70pP5oMTgE9IlNLym0zGN8YTNamYIr4U7xxOy4Jq',
                'Authorization': 'Bearer ' + idToken
            },
            
            body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(data => {

            setStats(data);
            console.log(stats);
            
            const dates = Object.values(data.results)[0].map(entry => formatDate(entry.day));
            const transformedData = Object.entries(data.results).map(([dimension, counts]) => {
                const friendlyDimensionName = dimensionNamesMapping[dimension] || dimension;
                const countsByDay = {};
                counts.forEach(({ day, count }) => {
                    const formattedDay = formatDate(day);
                    countsByDay[formattedDay] = count;
                });           
                return { dimension: friendlyDimensionName, ...countsByDay };
            });
            setDates(dates);
            setTransformedData(transformedData);

            const lineColors = [
                'rgba(225, 199, 1, 1)', 
                'rgba(54, 162, 235, 1)', 
                'rgba(255, 206, 86, 1)', 
                'rgba(75, 192, 192, 1)',  
                'rgba(153, 102, 255, 1)', 
                'rgba(255, 159, 64, 1)',  
                'rgba(123, 159, 64, 1)',  
              ];

            const chartData = {
                labels: dates, 
                datasets: transformedData.map((group, index) => ({
                    label: group.dimension,
                    data: dates.map(date => group[date] || 0), 
                    fill: false,
                    //backgroundColor: 'rgba(75,192,192,0.4)',
                    //borderColor: 'rgba(75,192,192,1)',
                    borderColor: lineColors[index % lineColors.length], // Cycle through colors
                    backgroundColor: lineColors[index % lineColors.length], // Optional: if you want the fill color to match the line
                    borderWidth:1,
                    }))
            };
    
            setChartData(chartData);
            setIsLoading(false);
        })
        .catch((error) => {
            console.error('Error:', error);
            setStats([]);
            setIsLoading(false);
        });

    };

    const LineChartPanel = ({ data }) => {
        console.log(data);
        const options = {
            scales: {
              y: {
                ticks: {
                  stepSize: 500,
                },
                suggestedMin: 0, // Adjust based on your data
                suggestedMax: 2000, // Adjust based on your data
              },
            },
            // Include other options as needed
          };
          
        return <Line data={data} options={options} height={150}/>;
    };

    const DataTable = ({ data, dates }) => {
        return (

          <table className='csvTable'>
            <thead>
              <tr>
                <th>Dimension</th>
                {dates.map(date => <th key={date}>{date}</th>)}
              </tr>
            </thead>
            <tbody>
              {data.map(row => (
                <tr key={row.dimension}>
                  <td>{row.dimension}</td>
                  {dates.map(date => <td key={date}>{row[date]}</td>)}
                </tr>
              ))}
            </tbody>
          </table>
        

        );
      };
      
    return (
        <Formik
        initialValues={{ file: null, submitType:'' }}
        onSubmit={handleSubmit}

        >
        {({ errors, touched, setFieldValue }) => (
            <Form>

            <div className="flex-container-1">
                        
                <div className="upload-container">
                    <Navbar link={link} linkText={linkText}/>

                    <div className="upload-contents-container">

                            <div>
                                {isLoading && (
                                    <div className="spinner">
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                    </div>
                                )}
                            </div>
                     

                        <div className="upload-text-container">
                            {stats ? (
                                <DataTable data={transformedData} dates={dates} />
                            ) : (
                                // This is the "else" part
                                <div>
                                    Invalid stats data.
                                </div>
                            )}
                        </div>

                        <div>
                            {Object.keys(chartData).length > 0 && <LineChartPanel data={chartData} />}
                        </div>


 
                    </div>
                </div>    
            </div>


            </Form>
        )}
        </Formik>
    );
};

export default GetStats;
